export const mqSmall = window.matchMedia('(max-width: 550px)');
export const mqMedium = window.matchMedia('(max-width: 768px)');
export const mqMediumLarge = window.matchMedia('(max-width: 1024px)');
export const mqMediumLargeNav = window.matchMedia('(max-width: 1300px)');
export const mqLarge = window.matchMedia('(max-width: 1200px)');